import { InjectionToken } from '@angular/core';
import { EnvironmentConfig } from '../interfaces/environment.interface';

export const APP_ENVIRONMENT = new InjectionToken<EnvironmentConfig>('app.environment');